import React, { useContext, useEffect } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  
  // Apply theme to document's body element
  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    // Store theme preference
    localStorage.setItem('theme', theme);
  }, [theme]);
  
  return (
    <button 
      className={`theme-toggle ${theme}`} 
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <span className="toggle-icon">
        {theme === 'light' ? '🌙' : '☀️'}
      </span>
      <span className="toggle-ripple"></span>
    </button>
  );
};

export default ThemeToggle;
